module.exports = __webpack_public_path__ + "images/home/fioleDeveloppeurWeb.aad725c0.svg";